import objectAssign from "object-assign";
import actionTypes from "actionTypes";

const initialState = {
	isLoading: false,
	layoutClassName: "",
	secondaryHeader: {
		isVisible: false,
		childComponent: null
	},
	backendErrorMessage: ""
};

export default function commonReducer(state = initialState, action) {
	let newState = null;
	switch (action.type) {
		case "SET_LOADING":
			newState = objectAssign({}, state);
			newState.isLoading = action.loading;
			return newState;
		case "SET_SECONDARY_HEADER":
			return {
				...state,
				secondaryHeader: {
					...action.payload
				}
			};
		case actionTypes.SET_BACKEND_ERROR_MESSAGE:
			newState = objectAssign({}, state, {
				backendErrorMessage: action.errorMessage
			});
			return newState;
	}
	return state;
}
